import React ,{Suspense} from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Header from './Header.js'
import ApiPollingAlert from './pages/alert_notification_display.js';
import { ConstructionIcon } from 'lucide-react';

const StockLinksPage = React.lazy(() => import('./pages/stock_links.js'))
const Fetchtickdata = React.lazy(() => import('./pages/Fetch_tick_Data.js'));
const BTSTPage = React.lazy(() => import('./pages/btst-data.js'));

const PostMsg = React.lazy(() => import('./pages/post_msg.js'));
const Flatcandle = React.lazy(() => import('./pages/flat_candle.js'))
const Card =  React.lazy(() => import('./pages/dashboard.js'))
const IndustryDashboard = React.lazy(() => import('./pages/dashboard_1.js'))
const F_o_dashboard = React.lazy(() => import('./pages/f_o_dashboard.js'))
const Gainers_Losers_Dashboard = React.lazy(() => import('./pages/gainers_losers_dashboard.js'))
const Gainers_Losers_Dashboard_ind = React.lazy(() => import('./pages/gainers_losers_ind.js'))
const Result_impact_strategy = React.lazy(() => import('./pages/result_impact.js'))
const StockDuraion_strategy = React.lazy(() => import('./pages/stock_duration .js'))
const F_O_stock_Details = React.lazy(() => import('./pages/f_o_stock_details.js'))
const F_O_List_Data = React.lazy(() => import('./pages/f_o_list.js'))
const StockMessages = React.lazy(() => import('./pages/stocknotifications.js'))
const F_O_Watchlist = React.lazy(() => import('./pages/watchlist.js'))
const Watchlist = React.lazy(() => import('./pages/all_stock_watchlist.js'))
const IndustryScores = React.lazy(() => import('./pages/f&o_industry.js'))
const Notification = React.lazy(() => import('./pages/f_o_stock_details.js'))
const Pullback_data = React.lazy(() => import('./pages/pullback_strategy.js'))
const Alert_stock_display = React.lazy(() => import('./pages/alert_stock_display.js'))
const Nifty_Daily = React.lazy(() => import('./oldsite/nifty_daily.js'))
const Industry_Trend_page = React.lazy(() => import('./oldsite/industry_trend_page.js'))
const Ind_StockDetailsPage = React.lazy(() => import('./oldsite/indust_stock_details.js'))
const OS_Stock_Details = React.lazy(() => import('./oldsite/stock_detail.js'))
const F_O_Details = React.lazy(() => import('./oldsite/future_option.js'))
const InsiderTrading  = React.lazy(() => import('./oldsite/inside_strategy.js'))
const Industry_Details = React.lazy(() => import('./oldsite/industryDetailsPage.js'))
const Strategy  = React.lazy(() => import('./oldsite/strategy.js'))
const Stage  = React.lazy(() => import('./oldsite/stage.js'))
const Index_Contributor = React.lazy(() => import('./pages/index_contributor.js'))
const Weekhigh_stock = React.lazy(() => import('./pages/weekhigh_stock.js'))
const OptionsDataTable = React.lazy(() => import('./pages/ltp_index.js'))
const StockOptions = React.lazy(()=> import('./pages/options.js'))
const INDEX_STOCK_OPTIONS = React.lazy(() => import('./pages/option_page.js'))
const Pattern_stock = React.lazy(() => import('./pages/pattern_stock.js'))
const OIhigh = React.lazy(() => import('./pages/oi_high.js'))
const StockTickerGrid = React.lazy(() => import('./pages/stock_timeseriesdata.js'))
const VR_SR_Blast = React.lazy(() => import('./pages/vr_sr_blast.js')) 
const TickerRanksTable = React.lazy(() => import('./pages/stock_rank.js')) 
const StockRanklive = React.lazy(() => import('./pages/Rankchange.js')) 
const Momentum_stock = React.lazy(() => import('./pages/momentum_stock.js'))
const SectorRankHistory = React.lazy(() => import('./pages/sectorRankchange.js'))
const Volume_blast_Momentum_stock = React.lazy(() => import('./pages/vol_blast_momentum_stck.js'))
const SectorPerformanceHeatmap = React.lazy(() => import('./pages/sectorheatmap.js'))
const StockRankhistory = React.lazy(() => import('./pages/stockRankhistory.js'))
const StockLog = React.lazy(() => import('./pages/log.js'))
const TrendingstockDashboard = React.lazy(() => import('./pages/recent_trendingstock.js'))
const TopGainerDetails = React.lazy(() => import('./pages/top_stock_detail.js'))
const PremarketTopGL = React.lazy(() => import('./pages/premarket_top_gl.js'))
const CandlestickChart = React.lazy(() => import('./pages/candlestick_chart.js'))
const Kite_chart = React.lazy(() => import('./pages/test_kite.js'))
const ResultAnalysis = React.lazy(() => import('./pages/result_analysisi.js'))
const QueryPage = React.lazy(() => import('./pages/stock_filter.js'))
const DrawdownChanges = React.lazy(() => import('./pages/drawdown_changes.js'))
const PortfolioLayout = React.lazy(() => import('./pages/portfolio_layout.js'))
const PortfolioDashboard = React.lazy(() => import('./pages/portfolio_dashboard.js'))
const PortfolioHoldings = React.lazy(() => import('./pages/portfolio_holdings.js'))
const PortfolioPositions = React.lazy(() => import('./pages/portfolio_positions.js'))
const PortfolioOrders = React.lazy(() => import('./pages/portfolio_orders.js'))
const BasketOrders = React.lazy(() => import('./pages/BasketOrders.js'))
const AlertTriggerOrder = React.lazy(() => import('./pages/AlertTriggerOrder.js'))
const AthTestingTable = React.lazy(() => import('./pages/ath_testing.js'))






function App() { 
  return (
    <Router>
      <div>
        {/* <ApiPollingAlert 
          apiUrl="https://live1.finstrats.com/alert_notification" 
          pollingInterval={30000} 
        /> */}
        <Header />
        <Toaster position="top-right" />
        <Suspense>
          <Routes>
            <Route path="/kite_graph_data" element={<Kite_chart />} />
            <Route path="/card" element={<Card />} />
            <Route path="/highvolume" element={<StockLinksPage />} />
            <Route path="/fetch-data" element={<Fetchtickdata />} />
            <Route path="/btst-data" element={<BTSTPage />} />
            <Route path="/flat_candle" element={<Flatcandle />} />
            <Route path="/post" element={<PostMsg />} />
            <Route path="/industry" element={<IndustryDashboard />} />
            <Route path="/f_o_dashboard" element={<F_o_dashboard />} />
            <Route path="/" element={<Gainers_Losers_Dashboard/>} />
            <Route path="/gainers_losers_ind" element={< Gainers_Losers_Dashboard_ind/>} />
            <Route path= "/strategies_res" element={<Result_impact_strategy />}/>
            <Route path= "/strategies_duration" element={<StockDuraion_strategy />}/>
            <Route path= "/f_o_stocks_details" element={<F_O_stock_Details />}/>
            <Route path ="/f_o_listdata" element = {<F_O_List_Data/>}/>
            <Route path ="/notification" element = {<StockMessages/>}/>
            <Route path ="/f_o_watchlist" element = {<F_O_Watchlist/>}/>
            <Route path ="/watchlist" element = {<Watchlist/>}/>
            <Route path ="/f_o_industry_score" element = {<IndustryScores/>}/>
            <Route path ="/test" element = {<Notification/>}/>
            <Route path ="/pullback" element = {<Pullback_data/>}/>
            <Route path ="/alert_stock" element = {<Alert_stock_display/>}/>
            <Route path ="/index_contributor" element = {<Index_Contributor/>}/>
            <Route path ="/weekhigh_stock" element = {<Weekhigh_stock/>}/>
            <Route path ="/optionchain" element = {<OptionsDataTable/>}/>
             <Route path ="/stock_options" element = {<StockOptions/>}/>
            <Route path ="/options" element = {<INDEX_STOCK_OPTIONS/>}/>
            <Route path ="/candle_pattern" element = {<Pattern_stock/>}/>
            <Route path ="/highoi" element = {<OIhigh/>}/>
            <Route path ="/stock_timeseries" element = {<StockTickerGrid/>}/>
            <Route path ="/vol_blast" element = {<VR_SR_Blast/>}/>
            <Route path ="/stock_rank" element = {<TickerRanksTable/>}/>
            <Route path ="/rank_change" element = {<StockRanklive/>}/>
            <Route path ="/momentum_stock" element = {<Momentum_stock/>}/>
            <Route path ="/sector_heatmap" element = {<SectorPerformanceHeatmap/>}/>
            <Route path ="/sector_rank_change" element = {<SectorRankHistory/>}/>
            <Route path ="/stock_rank_change" element = {<StockRankhistory/>}/>
            <Route path ="/volume_blast_intraday" element = {<Volume_blast_Momentum_stock/>}/>
            <Route path ="/tradelog" element = {<StockLog/>}/>
            <Route path ="/trendingstock" element = {<TrendingstockDashboard/>}/>
            <Route path ="/gainersdetails" element = {<TopGainerDetails/>}/>
            <Route path ="/premarket_top_gl" element = {<PremarketTopGL/>}/>
            <Route path ="/day_chart" element = {<CandlestickChart/>}/>
            <Route path ="/result_analysis" element = {<ResultAnalysis/>}/>
            <Route path ="/drawdown_changes" element = {<DrawdownChanges/>}/>
            <Route path ="/filter-with-query" element = {<QueryPage/>}/>
            <Route path ="/ath_testing" element = {<AthTestingTable/>}/>


            

            {/* old site url */}
            <Route path ="/market" element = {<Nifty_Daily/>}/>
            <Route path ="/industry_trend" element = {<Industry_Trend_page/>}/>
            <Route path ="/stockdetails" element = {<Ind_StockDetailsPage/>}/>
            <Route path ="/stocks" element = {<OS_Stock_Details/>}/>
             <Route path ="/f_o" element = {<F_O_Details/>}/>
            <Route path ="/insider" element = {<InsiderTrading/>}/>
            <Route path = "/industry_details" element={<Industry_Details />} />
            <Route path = "/strategy" element={<Strategy />} />
            <Route path = "/stage" element={<Stage />} />
{/* 
            {/* Portfolio Routes */}
            <Route path="/portfolio" element={<PortfolioLayout />}>
              <Route index element={<PortfolioDashboard />} />
              <Route path="holdings" element={<PortfolioHoldings />} />
              <Route path="positions" element={<PortfolioPositions />} />
              <Route path="orders" element={<PortfolioOrders />} />
              <Route path="basket" element={<BasketOrders />} />
              <Route path="ato" element={<AlertTriggerOrder />} />

            </Route> 

             
          </Routes>
        </Suspense> 
      </div>
    </Router>
  );
}

export default App;



// import React, { Suspense } from 'react';
// import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

// import Header from './Header.js'

// const StockLinksPage = React.lazy(() => import('./pages/stock_links.js'))
// const Fetchtickdata = React.lazy(() => import('./pages/Fetch_tick_Data.js'));
// const BTSTPage = React.lazy(() => import('./pages/btst-data.js'));
// const Indices = React.lazy(() => import('./pages/indices.js'));
// const PostMsg = React.lazy(() => import('./pages/post_msg.js'));
// const Flatcandle = React.lazy(() => import('./pages/flat_candle.js'))
// const Card = React.lazy(() => import('./pages/dashboard.js'))

// // Create a layout component to conditionally render Header
// const Layout = ({ children }) => {
//   const location = useLocation();
  
//   return (
//     <>
//       {location.pathname !== '/dashboard' && <Header />}
//       {children}
//     </>
//   );
// };

// function App() {
//   return (
//     <Router>
//       <Layout>
//         <Suspense>
//           <Routes>
//             <Route path="/" element={<StockLinksPage />} />
//             <Route path="/fetch-data" element={<Fetchtickdata />} />
//             <Route path="/btst-data" element={<BTSTPage />} />
//             <Route path="/flat_candle" element={<Flatcandle />} />
//             <Route path="/index" element={<Indices />} />
//             <Route path="/post" element={<PostMsg />} />
//             <Route path="/dashboard" element={<Card />} />
//           </Routes>
//         </Suspense>
//       </Layout>
//     </Router>
//   );
// }

// export default App;
